import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

interface Option {
  value: string;
  label: string;
}

export interface PatientSourceSelectProps {
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  error?: string;
  showErrors?: boolean;
  disabled?: boolean;
}

const PatientSourceSelect: React.FC<PatientSourceSelectProps> = ({
  options,
  value,
  onChange,
  error,
  showErrors,
  disabled = false,
}) => {
  return (
    <FormControl fullWidth size="small" error={!!(showErrors && error)}>
      <InputLabel>Select Patient Source</InputLabel>
      <Select
        label="Select Patient Source"
        value={value}
        onChange={(e) => onChange(e.target.value as string)}
        disabled={disabled}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PatientSourceSelect;
